import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";
import ghostsAudio from "@/assets/artificial-ghosts.mp3.asset.json";
import ghostsCover from "@/assets/artificial-ghosts-cover.jpg.asset.json";

export const Route = createFileRoute("/lab/ecologias")({
  head: () => labHead(
    "/lab/ecologias",
    "Ecologias da Percepção",
    "Laboratório de Ecologias da Percepção: panorama 360° de Luiza Jesus do Prado, animado, com som e modo VR.",
    "| Ecologias da Percepção",
  ),
  component: EcologiasLab,
});

function EcologiasLab() {
  return (
    <LabPage
      src="https://luizajprado.github.io/sirene/ecologias/"
      title="Ecologias da Percepção"
      projectSlug="ecologies-of-perception"
      projectTitle={{
        pt: "Ecologias da Percepção",
        en: "Ecologies of Perception",
        es: "Ecologías de la Percepción",
      }}
      sound={{
        src: ghostsAudio.url,
        cover: ghostsCover.url,
        title: "Artificial Ghosts",
        artist: "Célio Barros + Hifa Cybe",
      }}
    />
  );
}
